interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbListProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbListProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `http://wa25w.cn/${item.url}`,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 lg:px-10 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
          {items.map((item, index) => (
            <li key={item.url} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-300 mx-1">/</span>
              )}
              {index === items.length - 1 ? (
                <span className="text-foreground-700 font-medium">{item.name}</span>
              ) : (
                <a href={item.url} className="hover:text-primary-500 transition-colors cursor-pointer">
                  {item.name}
                </a>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}